var map = {
	"./apple/httpClient": 479,
	"./isomorphic/httpClient": 496,
	"./sony/trilithium/httpClient": 501
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 478;


//////////////////
// WEBPACK FOOTER
// ./src/services/platforms ^\.\/.*\/httpClient$
// module id = 478
// module chunks = 0